module.exports = __webpack_public_path__ + "img/zdjl.2d19cb7b.svg";